import { AzureCommunicationTokenCredential } from '@azure/communication-common';

import { api } from '.';

import type { GuestChatEndedBy } from '../models/chat';
import { RaygunErrorHandlerService } from '../services/raygun';

const { logError } = RaygunErrorHandlerService();

// reference: https://docs.microsoft.com/en-us/javascript/api/overview/azure/communication-common-readme?view=azure-node-latest
export const createAutoRefreshingCredential = (token: string) => {
  return new AzureCommunicationTokenCredential(token);
};

export const canTakeSurvey = async (thread_id: string) => {
  try {
    const response = await api.post<{ time_expired: boolean; reported_abuse: boolean }>(
      '/advocate/v0_can_take_survey',
      { thread_id },
    );
    return response;
  } catch (error) {
    logError(error, ['api/chat', 'canTakeSurvey']);
  }
};

export const getChat = async (isAdvocate: boolean, chat_id: string | undefined) => {
  try {
    if (!chat_id) return;
    const url = isAdvocate ? '/advocate/v1_get_chat' : '/guest/v1_get_chat';
    const response = await api.post<{
      started: boolean;
      ended: boolean;
      ended_by: GuestChatEndedBy;
    }>(url, { chat_id });
    return response;
  } catch (error) {
    logError(error, ['api/chat', 'getChat']);
  }
};

export const recordMessageTimestamp = async (thread_id: string, message_id: string, sender: string) => {
  try {
    const response = await api.post<number>('/advocate/v0_chat_message_sent', { thread_id, message_id, sender });
    return response;
  } catch (error) {
    logError(error, ['api/chat', 'recordMessageTimestamp']);
  }
};
